import { Link } from 'react-router-dom';

export default function FinalCTASection() {
  return (
    <section className="py-20 sm:py-32 px-4 sm:px-6 relative overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/51b4ce710c8fddbc7a43154373c013ea.jpg"
          alt=""
          className="w-full h-full object-cover object-center"
          loading="lazy"
          width="1920"
          height="800"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-emerald-900/90 via-teal-900/90 to-slate-900/95"></div>
      </div>

      {/* Décoratifs */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-emerald-500/15 rounded-full blur-3xl -translate-x-1/3 -translate-y-1/3 pointer-events-none"></div>
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-teal-400/10 rounded-full blur-3xl translate-x-1/4 translate-y-1/4 pointer-events-none"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-emerald-500/20 border border-emerald-400/30 text-emerald-300 px-5 py-2 rounded-full text-xs font-bold mb-8 uppercase tracking-widest">
          <i className="ri-flashlight-fill text-emerald-400 animate-pulse"></i>
          Offre de lancement — Places limitées
        </div>

        <h2 className="text-3xl sm:text-5xl md:text-6xl font-black text-white mb-5 leading-tight">
          Prêt à Lancer
          <br />
          <span className="bg-gradient-to-r from-emerald-400 to-teal-400 bg-clip-text text-transparent">
            Votre Site Pro ?
          </span>
        </h2>
        <p className="text-base sm:text-xl text-white/60 mb-10 sm:mb-12 max-w-xl mx-auto font-medium">
          Devis gratuit et sans engagement — réponse personnalisée sous 24h
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <Link
            to="/offres"
            className="group inline-flex items-center justify-center gap-3 bg-gradient-to-r from-emerald-500 to-teal-500 text-white px-10 sm:px-14 py-4 sm:py-5 rounded-full text-base sm:text-xl font-black shadow-2xl shadow-emerald-500/40 hover:shadow-emerald-500/60 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-store-2-line text-xl"></i>
            <span>Voir Nos Offres</span>
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
          </Link>
          <a
            href="tel:+33651872435"
            className="inline-flex items-center justify-center gap-3 bg-white/10 backdrop-blur-md border border-white/25 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill text-emerald-400 text-lg"></i>
            <span>06 51 87 24 35</span>
          </a>
        </div>

        {/* Réassurance */}
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm text-white/45 font-semibold">
          <span className="flex items-center gap-1.5"><i className="ri-check-line text-emerald-400"></i>À partir de 69€/mois</span>
          <span className="flex items-center gap-1.5"><i className="ri-check-line text-emerald-400"></i>Sans engagement</span>
          <span className="flex items-center gap-1.5"><i className="ri-check-line text-emerald-400"></i>Livraison en 7 jours</span>
          <span className="flex items-center gap-1.5"><i className="ri-check-line text-emerald-400"></i>100% satisfaits</span>
        </div>
      </div>
    </section>
  );
}
